<template>
  <div>
    <CRow>
      <CCol col="12" md="12" lg="12">
        <h4><strong>Data Pengalaman Kerja</strong></h4>
        <hr />
      </CCol>
    </CRow>

    <CRow>
      <CCol col="12" md="12" lg="12">
        <b-button variant="primary" v-b-modal.modal-input-kerja><CIcon name="cil-plus" /> Tambah Data</b-button>
      </CCol>
    </CRow>

    <CRow class="mt-3">
      <CCol col="12" md="12" lg="12">
        <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy">
          <template #actions="{ item }">
            <td>
              <!-- <b-button
                variant="warning"
                class="mr-1"
                v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                v-b-modal.modal-edit-kerja
                @click="dataPengalaman = item"
              >
                <CIcon name="cil-pencil" />
              </b-button> -->
              <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipHapus" v-b-modal.modal-delete-kerja @click="dataPengalaman = item">
                <CIcon name="cil-trash" />
              </b-button>
            </td>
          </template>
        </CDataTable>
      </CCol>
    </CRow>

    <modal-input :data="data" @alertFromChild="triggerAlert($event)" />
    <!-- <modal-edit /> -->
    <modal-delete :dataPengalaman="dataPengalaman" @alertFromChild="triggerAlert($event)" />
  </div>
</template>
<script>
import modalInput from "./modalInput.vue";
// import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";
export default {
  props: ["data",'activeTab'],
  components: {
    modalInput,
    // modalEdit,
    modalDelete,
  },
  data() {
    return {
      items: [],
      dataPengalaman: "",
      fields: [
        {
          key: "no",
          label: "No",
          class: "table-number text-center",
          sortDirection: "desc",
          filter: false,
        },
        {
          key: "namaPerusahaan",
          label: "Perusahaan",
          sortDirection: "desc",
          _style: "width: 40%;",
          class: "text-left",
          filter: false,
        },
        {
          key: "jabatan",
          label: "Jabatan",
          sortDirection: "desc",
          _style: "width: 30%;",
          class: "text-left",
          filter: false,
        },
        {
          key: "tahun",
          label: "Tahun",
          sortDirection: "desc",
          _style: "width: 15%;",
          class: "text-left",
          filter: false,
        },
        {
          key: "actions",
          label: "Actions",
          sortDirection: "desc",
          _style: "width: 15%;",
          class: "table-option-3 text-center",
          filter: false,
          sorter: false,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      tableBusy: false,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  watch: {
    "data.dataKaryawanId"(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getDataAsuransi();
      }
    },
    activeTab(newVal) {
      if (newVal === 3) {
        this.getPengalamanKerja();
        // this.getDataAsuransi();
      }
    },
  },

  mounted() {},
  methods: {
    async getPengalamanKerja() {
      let vm = this;
      vm.pengalaman = [];
      let listPengalamanKerja = await vm.$axios.get("dataKaryawan/detailsByDataKaryawanId/" + vm.$route.query.dataKaryawanId);
      // console.log('listPengalamanKerja', listPengalamanKerja);
      vm.items =
        listPengalamanKerja.data.status == 200 && listPengalamanKerja.data.data.length > 0
          ? listPengalamanKerja.data.data[0].pengalamanKerja.map((x, idx) => {
              return {
                ...x,
                no: idx + 1,
                tahun: x.tahun || " - ",
              };
            })
          : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.$emit("update");
      vm.getPengalamanKerja();
    },
  },
};
</script>
